import { ReactNode, Ref } from 'react';

import { InputReg, InputRegProps, Label, LabelProps, ValidatedField, ValidatedFieldProps } from '@britishcouncil/react-registration-platform';

import { cn } from '@/core/helpers/cn';

export type FormInputProps = InputRegProps &
  Pick<ValidatedFieldProps, 'errorInline' | 'errorSubmittion'> &
  Pick<LabelProps, 'helpText'> & {
    label?: ReactNode;
    ref?: Ref<HTMLInputElement>;
  };

export const FormInput = ({ errorInline, className, errorSubmittion, label, helpText, ref, ...props }: FormInputProps) => {
  return (
    <div>
      {label ? (
        <Label placeholder="" helpText={helpText} htmlFor={props.name || props.id}>
          {label}
        </Label>
      ) : null}
      {/* Class reg-react-select__input can be delete after refacor all inputs and remove box-shadow styles form global-css  */}
      <ValidatedField errorInline={errorInline} errorSubmittion={errorSubmittion}>
        <InputReg className={cn('reg-react-select__input mt-1', className)} ref={ref} {...props} />
      </ValidatedField>
    </div>
  );
};
